<template>
  <div>
    <div v-if="logs.total > 0">
      <px-lista-logs
        :logs="logs"
        :loading="loading"
        :on-change-options="onChangeOptions"
        :options-list="optionsList"
        @update="onClickRefresh"/>
    </div>
    <div v-else>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <v-row>
              <v-col cols="12">
                <div class="text-center">
                  Nenhum log encontrado
                </div>
              </v-col>
            </v-row>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import IntegracaoService from '@/api/integracao-service';
import paginationMixin from '@/mixins/pagination-mixin';

export default {
  mixins: [paginationMixin],
  props: {
    idCompra: Number,
  },
  data() {
    return {
      show: false,
      logs: {
        content: [],
        total: 0,
      },
      listOptions: {
        page: 1,
        limit: 5,
        offset: 0,
        filter: '',
        sort: 'createdIn',
        sortDesc: true,
      },
      optionsList: {},
      loading: false,
    };
  },
  computed: {
    icon() {
      return this.show ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
  },
  methods: {
    onClickRefresh() {
      this.getLogs();
    },
    resetPage() {
      this.listOptions = this.resetPagination(this.listOptions);
      this.optionsList = this.pageToOptions(this.listOptions);
    },
    onChangeFilter() {
      this.resetPage();
      this.getLogs();
    },
    onChangeOptions(options) {
      this.optionsList = options;
      this.listOptions = this.optionsToPage(this.listOptions, this.optionsList);
      this.getLogs();
    },
    getLogs() {
      this.loading = true;

      const params = {
        limit: this.listOptions.limit,
        offset: this.listOptions.offset,
        query: this.buildQuery(this.listOptions),
      };
      IntegracaoService.getLogsCompras(this.idCompra, params)
        .then((response) => {
          this.logs = response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.optionsList = this.pageToOptions(this.listOptions);
    this.getLogs();
  },
};
</script>
